// 2-tier RBAC helpers (owner / team). Owner always has full access.
export const isOwner = (u) => u?.role === 'owner';
export const isInternal = (u) => u?.role === 'owner' || u?.role === 'team';
export const canFeature = (u, f) => isOwner(u) || !!(u?.permissions?.features?.[f]);
export const canAction = (u, a) => isOwner(u) || !!(u?.permissions?.actions?.[a]);
export const canTab = (u, t) => isOwner(u) || (u?.permissions?.tabs?.[t] !== false);
